import { useEffect, useState } from 'react'
import { KeycloakAdminService } from '@nv/auth'
import { AdminVoterService } from '@nv/services'

export const useGetEvent = (eventId: string) => {
  const [event, setEvent]: any = useState()
  useEffect(() => {
    const getEvents = async () => {
      const resp = await AdminVoterService.getEvent(eventId)
      if (resp?.event) {
        //@ts-ignore
        setEvent(resp.event)
      }
    }
    getEvents()
  }, [KeycloakAdminService.isLoggedIn(), eventId])

  return event
}
